// extracted by mini-css-extract-plugin
export default {"container":"style_container__eLyw-","header":"style_header__3jvM5","title":"style_title__bM0o2","child":"style_child__5IuGc"};